import _ from "lodash";
import "./Report.scss";
import moment from "moment";
import Extdialog from "./Extdialog";
import { useParams, useSearchParams } from "react-router-dom";
import writeXlsxFile from "write-excel-file";
import { AutoTextSize } from "auto-text-size";
import constants from "../../../../constants";
import Popup from "../../../CommonComponents/Popup";
import { getDataFromStorage } from "../../../../util";
import ReportHooks from "../../../../Hooks/ReportHooks";
import ReportFilterAndSearch from "./ReportFilterAndSearch";
import AlertContext from "../../../../context/AlertContext";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import HourglassBottom from "@mui/icons-material/HourglassBottom";
import { useTable, useSortBy, useGlobalFilter } from "react-table";
import Loading from "../../../Notification-Loading/Loading/Loading";
import { useDebouncedValue } from "../../../../Hooks/useDebounceValue";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import InfoSvg from "../../../../Svg/InfoSvg";

import React, {
  useRef,
  useState,
  Fragment,
  useEffect,
  useContext,
  useCallback,
  useMemo
} from "react";
import TimeSpent from "./TimeSpent";
import Tabs from "../../../CommonComponents/Tabs";
import Tooltip from "../../../CommonComponents/Tooltip";
import Chevrons_right from "../../../../Svg/Chevrons_right";
import Report_nodata from "../../../../Svg/Report/ReportNoDtaSvg";

const Report = () => {
  const Alert = useContext(AlertContext);
  const [loading,setLoading]=useState(false);
  const {
    setIsUnAuth,
    lpId,
    searchInput,
    searchText,
    performance,
    // setIsLoaded,
    reportTopics,
    reportStatus,
    setReportStatus,
    setSearchInput,
    setSearchText,
    isCommonPopup,
    reportTableRef,
    setReportTopics,
    typesAndModules,
    reportSortState,
    viewLearnerData,
    setTypesAndModules,
    hiddenColumnsInTable,
    setHiddenColumnsInTable,
    mid,
    qns,
    data,
    lpcid,
    setMid,
    setQns,
    libtype,
    lStatus,
    hasMore,
    setData,
    setLpcid,
    isLoaded,
    resLData,
    totalmids,
    setLStatus,
    setLibtype,
    setHasMore,
    setResLData,
    studentPage,
    setTotalmids,
    isGrandTotal,
    setShowNotify,
    selectedStatus,
    setStudentPage,
    setIsGrandTotal,
    setSelectedStatus,
    tesMode,
    setTesMode,
    collegeList, setCollegeList,
    selectedcollege, setSelectedcollege,
    branchList, setBranchList,
    selectedBranch, setSelectedBranch,
    selectedDropdown, setSelectedDropdown,
    openCDropdown, setOpenCDropdown,
    setSelectedChapters,
    setSelectedModule,
    setHoveredModule,
    setAppliedModules,
    openModuleDropdown,
    setOpenModuleDropdown,
    setStatus,
  } = useContext(AlertContext);

  const [searchParams, setSearchParams] = useSearchParams();

//  useEffect(() => {
//   const savedName = searchParams.get("name") || "";
//   if (!searchText && savedName) {
//     setSearchText(savedName);
//   }
// }, [searchParams, searchText, setSearchText]);

useEffect(() => {
  const savedName =
    searchParams.get("name") || sessionStorage.getItem("reportSearchName") || "";

  if (!searchText && savedName) {
    setSearchText(savedName);
    if (!searchParams.get("name")) {
      setSearchParams({ name: savedName });
    }
  } else if (searchText && !searchParams.get("name")) {
    setSearchParams({ name: searchText });
  }
}, [searchParams, searchText, setSearchText, setSearchParams]);

  const axios = useAxiosPrivate();
  const ReportHks = ReportHooks();
  const useCommonFunctionHks = useCommonFunctionHooks();

  const testPage = 1;

  const tableColumns = useRef([]);
  const debouncedSearchValue = useDebouncedValue(searchText||searchInput , 200);

  const [columns, setColumns] = useState([]);
  const [refreshPage, setRefreshPage] = useState(false);

  const [expandedTests, setExpandedTests] = useState({});
  const [headerStructure, setHeaderStructure] = useState({});
  const [studentsArray, setStudentsArray] = useState([]);

  const filteredStudents = useMemo(() => {
  const query = (searchText || "").trim().toLowerCase();
  if (!query) return studentsArray;

  return studentsArray.filter((student) => {
    return (
      (student?.name || "")
        .toString()
        .trim()
        .toLowerCase()
        .includes(query)
    );
  });
}, [studentsArray, searchText]);

  const expandMid = useRef(null);

  let initialState = {
    sortBy: reportSortState,
    globalFilter: searchText,
    hiddenColumns: hiddenColumnsInTable,
  };

  const {
    rows,
    prepareRow,
    headerGroups,
    getTableProps,
    setHiddenColumns,
    getTableBodyProps,
    setGlobalFilter,
  } = useTable(
    {
      data,
      columns,
      initialState,
    },
    useGlobalFilter,
    useSortBy
  );

  useEffect(() => {
    setGlobalFilter(debouncedSearchValue || undefined);
  }, [debouncedSearchValue, setGlobalFilter]);

  const { id, lpid } = useParams();
  const pageSize = 10;

  // Update when resLData changes
  useEffect(() => {
    if (resLData) {
      const studentsArray = Object.values(resLData);
      const headerStructure = getHeaderStructure(resLData);

      setStudentsArray(studentsArray);
      setHeaderStructure(headerStructure);

      let expandModule = Object.values(resLData)[0];
      if (expandMid.current === null || expandModule?.modules[expandMid.current] === undefined) setExpandedTests({}); // --for expanded tid remove
    }
  }, [resLData]);

  useEffect(() => {
    if (sessionStorage.getItem("lastLpid") !== lpid) {
      setHoveredModule(null);
      setOpenModuleDropdown(false);
      setSelectedModule(null);
      setSelectedChapters([]);
      setAppliedModules({});

      setSelectedDropdown({
        college: null,
        status: null,
        branch: null
      });
      // setSelectedDropdown(null);
      setSelectedcollege("");
      setSelectedBranch("");
      setOpenCDropdown(false);
      sessionStorage.setItem("lastLpid", lpId);
    } /* else {
        sessionStorage.removeItem("lastLpid");
        } */

    setExpandedTests({});
  }, [lpid]);

  /* Get college and branch */
  useEffect(() => {
    if (!id) return;

    const fetchColleges = async () => {
      try {
        const res = await axios.get("node/admin/batch/college", {
          params: { id },
          headers: { "Content-Type": "application/json" },
        });

        const data = res?.data?.data || [];

        const collegeData = data?.map((item, index) => ({
          checked: false,
          disabled: false,
          label: item.name,
          value: index + 1,
        }));

        setCollegeList(data.length > 1 ? [{ label: "All", value: 0 }, ...collegeData] : collegeData);
      } catch (err) {
        console.error(err);
      }
    };

    fetchColleges();
  }, [id]);

  useEffect(() => {
    if (!id) return;

    const fetchBranches = async () => {
      try {
        const params = { id };

        if (selectedcollege && selectedcollege !== "All") {
          params.cname = selectedcollege;
        }

        const res = await axios.get("node/admin/batch/college/branch", {
          params,
          headers: { "Content-Type": "application/json" },
        });

        const data = res?.data?.data || [];

        const branchData = data?.map((item, index) => ({
          label: item.branch,
          value: index + 1,
        }));

        setBranchList(data.length > 1 ? [{ label: "All", value: 0 }, ...branchData] : branchData);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranches();
  }, [id, selectedcollege]);

  // Get all unique modules and tests for header structure
  const getHeaderStructure = (resLData) => {
    const modules = {};
    const studentsData = Array.isArray(resLData) ? resLData : Object.values(resLData);
    studentsData.forEach(student => {
      Object.values(student.modules).forEach(module => {
        if (!modules[module.mid]) {
          modules[module.mid] = {
            ...module,
            tests: {}
          };
        }

        Object.values(module.tests).forEach(test => {
          if (!modules[module.mid].tests[test.tid]) {
            modules[module.mid].tests[test.tid] = test;
          }
        });
      });
    });

    return modules;
  };

  /* removing old data */
  useEffect(() => {
    if (resLData) {
      setResLData({});
    }
  }, [])


  const handleGetReport = async (
    lpId,
    studentPage,
    testPage,
    debouncedSearchValue,
    mid,
    lpcid,
    libtype,
    lStatus,
    qns = "",
    selectedStatus,
    totalmids,
    isGrandTotal,
    isexport = false,
    tesMode,
    selectedcollege,
    selectedBranch
  ) => {
    try {
      // setIsLoaded(true);
      setLoading(true);

      let tMode =
        tesMode === constants.MODE.PRACTICE_MODE ? `&tm=${tesMode}` : "";
      let clg = selectedcollege && selectedcollege !== "All" ? `&clg=${encodeURIComponent(selectedcollege)}` : "";
      let branch = selectedBranch && selectedBranch !== "All" ? `&branch=${encodeURIComponent(selectedBranch)}` : "";
      // API call

      const res = await axios.post(
        `node/admin/report/batch/lp?hsl=${pageSize}&vsl=${pageSize}&hs=${testPage}&vs=${studentPage}&name=${debouncedSearchValue}&st=${selectedStatus}&mid=${mid}&lpcid=${lpcid}&libt=${libtype}&active=${lStatus}&qns=${qns}&export=${isexport}&tmid=${totalmids}&gt=${isGrandTotal}` +
        tMode + clg + branch,
        JSON.stringify({ lpid: lpId }),
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );

      if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        // const learnersData = { ...resLData, ...(res.data.data ?? {}) };
        const learnersData = { ...(resLData || {}), ...(res.data.data ?? {}) };;
        const modules = res.data.modules ?? [];

        setRefreshPage(false);

        // Check if there is more data to load
        if (Object.keys(res.data.data).length < pageSize) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }

        // setResLData(learnersData);
        if (studentPage === 1 || debouncedSearchValue !== "") {
          setResLData(res.data.data ?? {});
        } else {
          // Only merge for pagination
          setResLData(prev => ({
            ...(prev || {}),
            ...(res.data.data ?? {})
          }));
        }

        // Build data for the table

        const buildData = await buildDataForShowInTable({
          learnersData: res.data.data,
          modules,
        });

        // Update report topics

        if (modules.length > 0) {
          const topicFilData = buildTopicFilData(modules, mid, lpcid, qns);
          setReportTopics(topicFilData);
        }

        // Update table columns and data

        if (studentPage === 1 && modules.length > 0) {
          setColumns(buildData.tableColumns);
          tableColumns.current = buildData.tableColumns;
        }

        const newData = buildData?.finalData ?? [];

        setData((pre) => (studentPage === 1 ? newData : [...pre, ...newData]));

        viewLearnerData.current =
          studentPage === 1
            ? newData
            : [...viewLearnerData.current, ...newData];

        return { data: buildData };
      } else {
        // Handle API errors

        setShowNotify({
          show: true,
          title:
            res.data.message?.resultCode ===
              constants.RESULT_STATUS.TECHNICAL_ERROR
              ? "Warning"
              : "Error",
          msg:
            res.data.message?.msg ??
            "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      useCommonFunctionHks.getCatchBlockDetails(error);
    } finally {
      // setIsLoaded(false);
      setLoading(false);

    }
  };

  // Memoize the function to avoid unnecessary re-renders

  const memoizedHandleGetReport = useCallback(handleGetReport, [
    axios,
    setData,
    pageSize,
    setHasMore,
    setColumns,
    setResLData,
    // setIsLoaded,
    setShowNotify,
    setReportTopics,
  ]);

  // useEffect to trigger the API call

  useEffect(() => {
    if (lpid) {
      memoizedHandleGetReport(
        lpid,
        studentPage,
        testPage,
        debouncedSearchValue,
        mid,
        lpcid,
        libtype,
        lStatus,
        qns,
        selectedStatus,
        totalmids,
        isGrandTotal,
        refreshPage,
        tesMode,
        selectedcollege,
        selectedBranch,
      );
    }
  }, [
    mid,
    qns,
    lpid,
    lpcid,
    libtype,
    lStatus,
    testPage,
    totalmids,
    studentPage,
    refreshPage,
    isGrandTotal,
    selectedStatus,
    debouncedSearchValue,
    memoizedHandleGetReport,
    refreshPage,
    typesAndModules,
    tesMode,
    selectedcollege,
    selectedBranch,
  ]);

  useEffect(() => {
    sessionStorage.removeItem("admin-reports-table-div");
    setStudentPage(1);
    if (reportTableRef.current) {
      reportTableRef.current.scrollTop = 0;
    }
  }, [debouncedSearchValue, mid, lpcid, selectedStatus, lpid, selectedcollege, selectedBranch]);

  const buildTopicFilData = (modules, mid, lpcid, qns) => {
    const topicsFilData = _.map(modules, (module) => {
      let moduleScore = 0; // Reset for each module
      let isModuleChecked = mid.split(",").includes(String(module.mid));

      let moduleFilData = {
        children: [],
        isModule: true,
        isTest: false,
        disabled: false,
        value: module.mid,
        label: module.mname,
        checked: isModuleChecked,
      };

      let moduleTests = _.chain(module.mconfig)
        .sortBy("orderno")
        .map((test) => {
          let isTestChecked =
            isModuleChecked || lpcid.split(",").includes(String(test.lpcid));

          let testFilData = {
            children: [],
            disabled: false,
            label: test.name,
            value: test.lpcid,
            checked: isTestChecked,
          };

          if (test.libtype === constants.libTypeIds.CODING_CHALLENGE) {
            testFilData.isModule = true;
            testFilData.isTest = true;

            let testScore = _.sumBy(test.topics, "targetscore");
            let topicScore = 0;

            const topicsChildren = _.flattenDeep(
              _.map(test.topics, (topic) => {
                const questions = topic.questions || [];

                topicScore += topic.targetscore;

                if (isTestChecked) {
                  return [
                    questions.map((qn, index) => ({
                      // checked:qns.split(",").map((ans) => ans.split("_")[0]).some((qnStr) => qnStr === `${qn.id}`),
                      checked:
                        (isTestChecked && qns === "") ||
                        qns.split(",").some((qnStr) => qnStr === `${qn.id}`),
                      disabled: false,
                      label: `${topic.topicname}-Q${index + 1} [${qn.targetscore
                        }]`,
                      value: qn.id,
                      qnno: index + 1,
                      isQn: true,
                      lpcid: test.lpcid,
                    })),
                  ];
                } else {
                  return [
                    questions.map((qn, index) => ({
                      checked: false,
                      disabled: false,
                      label: `${topic.topicname}-Q${index + 1} [${qn.targetscore
                        }]`,
                      value: qn.id,
                      qnno: index + 1,
                      isQn: true,
                      lpcid: test.lpcid,
                    })),
                  ];
                }

                // return [
                //   ..._.map(questions, (qn, index) => ({
                //     checked:
                //       isTestChecked ||
                //       qns.split(",").includes(`${test.lpcid}_${qn.id}`),
                //     disabled: false,
                //     label: `${topic.topicname}-Q${index + 1} [${
                //       qn.targetscore
                //     }]`,
                //     value: qn.id,
                //     qnno: index + 1,
                //     isQn: true,
                //     lpcid: test.lpcid,
                //   })),
                // ];
              })
            );

            // Append total score

            // topicsChildren.push({
            //   checked: false,
            //   disabled: false,
            //   label: `Total [${topicScore}]`,
            //   value: formataAndCreateAccessor(`${test.id + test.name}Total`),
            // });

            testFilData.children = topicsChildren;
            testFilData.label += ` [${testScore}]`;
          }

          moduleScore += test.targetscore; // Ensure correct module score calculation

          return testFilData;
        })
        .value(); // Ensure execution

      moduleFilData.children = moduleTests;

      // Append module total score

      // moduleFilData.children.push({
      //   checked: false,
      //   isMtotal: true,
      //   disabled: false,
      //   value: module.mid,
      //   label: `Total [${moduleScore}]`,
      // });

      return moduleFilData;
    });

    // topicsFilData.push({
    //   checked: false,
    //   disabled: false,
    //   isGrandTotal: true,
    //   value: "GrandTotal",
    //   label: "Grand Total",
    // });

    return topicsFilData;
  };

  const checkBatchHasCC = (modules) =>
    _.some(modules, (module) =>
      _.some(module.mconfig, { libtype: constants.libTypeIds.CODING_CHALLENGE })
    );

  const buildDataForShowInTable = async (data) => {
    let hiddenData = JSON.parse(JSON.stringify(data)),
      batchHasCC = checkBatchHasCC(hiddenData.modules),
      tableColumns = [],
      accessor = "Name";

    if (batchHasCC) {
      tableColumns.push({
        id: "Name",
        Header: "Name",
        columns: [
          {
            Header: "",
            id: "Namel2",
            columns: [
              {
                Header: "",
                id: "Namel3",
                columns: [
                  {
                    Header: "",
                    id: accessor,
                    accessor: "lname",
                    Cell: ({ value, row, column }) => (
                      <div className="report-learner-name">{value}</div>
                    ),
                  },
                ],
              },
            ],
          },
        ],
      });
    } else {
      tableColumns.push({
        id: "Name",
        Header: "Name",
        columns: [
          {
            id: accessor,
            accessor: "lname",
            Header: () => <div className="header-hide">{"Name"}</div>,
            Cell: ({ value, row, column }) => (
              <div className="report-learner-name">{value}</div>
            ),
          },
        ],
      });
    }

    let learnerData = buildLearnerData(hiddenData, tableColumns, batchHasCC);

    return learnerData;
  };

  /* OLD REPORT */
  // const handleGetCellColor = (percentage) => {

  //   if (performance) {
  //     if (percentage > 90 && percentage <= 100) {
  //       return "#77DD77";
  //     } else if (percentage > 75 && percentage <= 90) {
  //       return "#BEFD73";
  //     } else if (percentage > 60 && percentage <= 75) {
  //       return "#FDFD96";
  //     } else if (percentage > 50 && percentage <= 60) {
  //       return "#FF9899";
  //     } else if (percentage <= 50) {
  //       return "#FF6961";
  //     }
  //   } else {
  //     return "#F2F4F7";
  //   }
  // };

  const formataAndCreateAccessor = (accessor, property) => {
    let tempaccessor = accessor
      ?.replaceAll(" ", "")
      ?.replaceAll("[", "")
      ?.replaceAll("]", "")
      ?.replaceAll(".", "")
      ?.replaceAll("-", "");

    if (property === null || property === undefined) {
      return tempaccessor;
    }

    tempaccessor = tempaccessor + "." + property;

    return tempaccessor;
  };

  const buildLearnerData = (data, tableColumns, batchHasCC) => {
    let hiddenData = JSON.parse(JSON.stringify(data)),
      learnersData = JSON.parse(JSON.stringify(hiddenData.learnersData)),
      finalData = [];

    _.forEach(Object.entries(learnersData), ([lid, learner], lindex) => {
      finalData[lindex] = {};
      finalData[lindex].lid = lid;
      finalData[lindex].lname = learner.name;
      finalData[lindex].email = learner.email;
      finalData[lindex].college = learner.college;
      finalData[lindex].branch = learner.branch;

      let grandTotalColumn = {
        show: true,
        columns: [],
        id: `Grand Total`,
        Header: `Grand Total`,
      };

      const sortedModules = Object.entries(learner.modules || {})
        .sort((a, b) => Number(a[1].morderno) - Number(b[1].morderno));

      _.forEach(sortedModules,
        //       _.forEach(
        // Object.entries(learner.modules),

        ([morderno, module], mindex) => {
          let moduleColumns = {
            show: true,
            columns: [],
            Header: module.mname,
            id: formataAndCreateAccessor(`${module.mid + module.mname}`),
          },
            testTotalColumn = {
              show: true,
              id: `Total`,
              columns: [],
              Header: `Total`,
            };

          const sortedTest = Object.entries(module.tests || {})
            .sort((a, b) => Number(a[1].orderno) - Number(b[1].orderno));

          _.forEach(sortedTest, ([tid, test], tindex) => {
            // _.forEach(Object.entries(module.tests), ([tid, test], tindex) => {
            let testColumns,
              learnerTestScore = 0;

            if (test.libtype === constants.libTypeIds.CODING_CHALLENGE) {
              testColumns = {
                show: true,
                columns: [],
                Header: `${test.tname}`,
                testMode: test.testmode,
                id: formataAndCreateAccessor(`${test.tid + test.tname}`),
              };

              let topicsMap = {},
                modifiedTest = {
                  ...test,
                  topics: [],
                  targetscore: test.targetscore,
                },
                testScore = 0;

              _.forEach(Object.entries(test.topics), ([topicid, topic]) => {
                if (!topicsMap[topic.topicid]) {
                  topicsMap[topic.topicid] = {
                    questions: [],
                    targetscore: 0,
                    topicid: topic.topicid,
                    topicname: topic.topicname,
                  };

                  modifiedTest.topics.push(topicsMap[topic.topicid]);
                }

                topicsMap[topic.topicid].targetscore +=
                  topic.topicscore * topic.qncount ?? 0;

                for (let qn = 0; qn < topic.qncount; qn++) {
                  topicsMap[topic.topicid].questions.push({
                    id: topicid,
                    questionid: topic.questions[qn + 1]?.qnid,
                    status: topic.questions[qn + 1]?.status ?? 1,
                    qnno: topic.questions[qn + 1]?.qnno ?? qn + 1,
                    actualscore: topic.questions[qn + 1]?.actualscore ?? 0,
                    targetscore:
                      (topic.topicscore * topic.qncount) / topic.qncount,
                  });
                }
              });

              delete test.tconfig;

              Object.assign(test, modifiedTest);
              _.forEach(test.topics, (topic, topindex) => {
                let topicColumns = {
                  columns: [],
                  id: `${topic.topicname} [${topic.targetscore}]`,
                  Header: `${topic.topicname} [${topic.targetscore}]`,
                },
                  questions = topic.questions,
                  totalColumn = {
                    show: true,
                    id: `Total`,
                    columns: [],
                    Header: `Total`,
                  };

                testScore += topic.targetscore;

                for (let qn = 0; qn < questions.length; qn++) {
                  if (lindex === 0) {
                    topicColumns.columns.push({
                      show: true,
                      libTypeId: test.libtype,
                      Header: `Q${qn + 1} [${questions[qn].targetscore}]`,
                      id: formataAndCreateAccessor(
                        `${test.tid +
                        test.tname +
                        topic.topicname +
                        "Q" +
                        (qn + 1)
                        }`,
                        null
                      ),
                      accessor: formataAndCreateAccessor(
                        `${test.tid +
                        test.tname +
                        topic.topicname +
                        "Q" +
                        (qn + 1)
                        }`,
                        "actualscore"
                      ),
                      Cell: ({ value, row, column }) =>
                        buildCell(value, row.original[column.id], column),
                    });

                    if (qn === questions.length - 1) {
                      totalColumn.columns.push({
                        show: true,
                        Header: `[${testScore}]`,
                        id: formataAndCreateAccessor(
                          `${test.tid + test.tname}Total`,
                          null
                        ),
                        accessor: formataAndCreateAccessor(
                          `${test.tid + test.tname}Total`,
                          "actualscore"
                        ),
                        Cell: ({ value, row, column }) =>
                          buildCell(value, row.original[column.id], column),
                      });
                    }
                  }

                  learnerTestScore += questions[qn].actualscore ?? 0;
                  finalData[lindex][
                    formataAndCreateAccessor(
                      `${test.tid + test.tname + topic.topicname + "Q" + (qn + 1)
                      }`,
                      null
                    )
                  ] = {
                    mid: module.mid,
                    cs_per: 0,
                    testid: test.tid,
                    learnerid: lid,
                    repqueno: qn + 1,
                    lname: learner.name,
                    testname: test.tname,
                    modName: module.mname,
                    libtype: test.libtype,
                    duedate: test.duedate,
                    lpconfigid: test.lpcid,
                    topicid: topic.topicid,
                    testmode: test.testmode,
                    topicname: topic.topicname,
                    userstatus: learner.lstatus,
                    testqnno: questions[qn].qnno,
                    testduedate: test.testduedate,
                    testConfigId: questions[qn].id,
                    status: questions[qn].status ?? 1,
                    questionscount: topic.questions.length,
                    actualscore: questions[qn].actualscore,
                    score_per: test.actualscore
                      ? (test.actualscore * 100) / test.targetscore
                      : 0,
                    accessor: formataAndCreateAccessor(
                      `${test.tid + test.tname + topic.topicname + "Q" + (qn + 1)
                      }`,
                      null
                    ),
                    apiattributes: {
                      testid: test.tid,
                      learnerid: lid,
                      testqnno: questions[qn]?.qnno,
                      questionid: questions[qn]?.questionid,
                      lpid: sessionStorage.getItem("aPathId"),
                    },
                    filterattributes: {
                      type: "ccq",
                      libtype: test.libtype,
                      testmode: test.testmode,
                      hname: `${test.id + test.tname + topic.topicname + "Q" + (qn + 1)
                        }`,
                      proctored: test.proctored,
                    },
                  };
                }

                if (topindex === test.topics.length - 1)
                  finalData[lindex][
                    formataAndCreateAccessor(
                      `${test.tid + test.tname}Total`,
                      null
                    )
                  ] = {
                    mid: module.mid,
                    cs_per: 0,
                    status: 2,
                    libtype: 5,
                    testid: test.tid,
                    learnerid: lid,
                    timeleft: null,
                    score_per: null,
                    credibilityscore: 0,
                    lname: learner.name,
                    testname: test.tname,
                    modName: module.mname,
                    topicid: topic.topicid,
                    testConfigId: topic.id,
                    lpconfigid: test.lpcid,
                    targetscore: testScore,
                    testmode: test.testmode,
                    duedate: test.testduedate,
                    userstatus: learner.lstatus,
                    actualscore: learnerTestScore,
                    repqueno: questions.length + 2,
                    accessor: formataAndCreateAccessor(
                      `${test.tid + test.tname}Total`,
                      null
                    ),
                    apiattributes: {
                      testqnno: null,
                      learnerid: lid,
                      questionid: null,
                      lpid: sessionStorage.getItem("aPathId"),
                    },
                    filterattributes: {
                      libtype: 5,
                      type: "cct",
                      testmode: test.testmode,
                      hname: `${test.tid + test.tname}Total`,
                      proctored: test.proctored,
                    },
                  };

                if (lindex === 0) {
                  testColumns.columns.push(topicColumns);

                  if (topindex === test.topics.length - 1) {
                    testColumns.columns.push(totalColumn);
                  }
                }
              });
            } else {
              if (lindex === 0) {
                if (batchHasCC) {
                  testColumns = {
                    Header: "",
                    show: true,
                    id: `${test.tid + test.tname}`,
                    testMode:
                      test.libtype === constants.libTypeIds.ASSIGNMENT
                        ? constants.MODE.TEST_MODE
                        : test.testmode,
                    columns: [
                      {
                        Header: "",
                        show: true,
                        id: `${test.tid}`,
                        columns: [
                          {
                            show: true,
                            libTypeId: test.libtype,
                            Header: `${test.tname} [${test.targetscore}]`,
                            id: formataAndCreateAccessor(
                              `${test.tid}${test.tname}`,
                              null
                            ),
                            accessor: formataAndCreateAccessor(
                              `${test.tid}${test.tname}`,
                              "actualscore"
                            ),
                            Cell: ({ value, row, column }) =>
                              buildCell(value, row.original[column.id], column),
                          },
                        ],
                      },
                    ],
                  };
                } else {
                  testColumns = {
                    show: true,
                    libTypeId: test.libtype,
                    Header: `${test.tname} [${test.targetscore}]`,
                    id: formataAndCreateAccessor(
                      `${test.tid}${test.tname}`,
                      null
                    ),
                    testMode:
                      test.libtype === constants.libTypeIds.ASSIGNMENT
                        ? constants.MODE.TEST_MODE
                        : test.testmode,
                    accessor: formataAndCreateAccessor(
                      `${test.tid}${test.tname}`,
                      "actualscore"
                    ),
                    Cell: ({ value, row, column }) =>
                      buildCell(value, row.original[column.id], column),
                  };
                }
              }

              finalData[lindex][
                formataAndCreateAccessor(`${test.tid}${test.tname}`, null)
              ] = {
                mid: module.mid,
                testid: test.tid,
                cs_per: null,
                learnerid: lid,
                lname: learner.name,
                testname: test.tname,
                modName: module.mname,
                duedate: test.duedate,
                libtype: test.libtype,
                lpconfigid: test.lpcid,
                status: test.status ?? 1,
                userstatus: learner.lstatus,
                actualscore: test.actualscore,
                testmode: test.testmode ? test.testmode : 2,
                accessor: formataAndCreateAccessor(
                  `${test.tid}${test.tname}`,
                  null
                ),
                score_per: test.actualscore
                  ? (test.actualscore * 100) / test.targetscore
                  : 0,
                apiattributes: {
                  testid: test.tid,
                  learnerid: lid,
                  lpid: sessionStorage.getItem("aPathId"),
                },
                filterattributes: {
                  libtype: test.libtype,
                  testmode: test.testmode,
                  proctored: test.proctored,
                  hname: `${test.tid + test.tname}`,
                  type:
                    test.libtype === constants.libTypeIds.ASSIGNMENT
                      ? "assi"
                      : test.libtype === constants.libTypeIds.MCQ
                        ? "mcq"
                        : "des",
                },
              };
            }

            if (lindex === 0) {
              moduleColumns.columns.push(testColumns);
            }
          });

          if (
            module.hasOwnProperty("mtotal") &&
            module.mtotal !== null &&
            module.hasOwnProperty("mscore") &&
            module.mscore !== null
          ) {
            if (lindex === 0) {
              testTotalColumn.Header += `[${module.mtotal}]`;

              if (batchHasCC)
                testTotalColumn.columns.push({
                  Header: "",
                  show: true,
                  id: `${module.mid + module.mname}`,
                  columns: [
                    {
                      Header: "",
                      show: true,
                      id: formataAndCreateAccessor(
                        `${module.mid + module.mname}TestTotal`,
                        null
                      ),
                      accessor: formataAndCreateAccessor(
                        `${module.mid + module.mname}TestTotal`,
                        "actualscore"
                      ),
                      Cell: ({ value, row, column }) =>
                        buildCell(value, row.original[column.id], column),
                    },
                  ],
                });
              else delete testTotalColumn.columns;

              testTotalColumn.id = formataAndCreateAccessor(
                `${module.mid + module.mname}TestTotal`,
                null
              );

              testTotalColumn.accessor = formataAndCreateAccessor(
                `${module.mid + module.mname}TestTotal`,
                "actualscore"
              );

              testTotalColumn.Cell = ({ value, row, column }) =>
                buildCell(value, row.original[column.id], column);

              moduleColumns.columns.push(testTotalColumn);
            }

            finalData[lindex][
              formataAndCreateAccessor(
                `${module.mid + module.mname}TestTotal`,
                null
              )
            ] = {
              actualscore: module.mscore,
              filterattributes: {
                type: "moduletotals",
              },
            };
          }

          if (lindex === 0) {
            tableColumns.push(moduleColumns);
          }
        }
      );

      finalData[lindex][`GrandTotal`] = {
        actualscore: learner.grandscore,
        filterattributes: {
          type: "grandtotal",
        },
      };

      if (
        learner.hasOwnProperty("grandtotal") &&
        learner.grandtotal !== null &&
        learner.hasOwnProperty("grandscore") &&
        learner.grandscore !== null
      ) {
        if (lindex === 0) {
          if (batchHasCC) {
            grandTotalColumn.id += `[${learner.grandtotal}]`;
            grandTotalColumn.Header += `[${learner.grandtotal}]`;
            grandTotalColumn.show = true;
            grandTotalColumn.columns.push({
              Header: "",
              show: true,
              id: `${lid}GrandTotal`,
              columns: [
                {
                  show: true,
                  Header: "",
                  id: `${lid + learner.lname}GrandTotal`,
                  columns: [
                    {
                      Header: "",
                      show: true,
                      id: `GrandTotal`,
                      accessor: `GrandTotal.actualscore`,
                      Cell: ({ value, row, column }) =>
                        buildCell(value, row.original[column.id], column),
                    },
                  ],
                },
              ],
            });
          } else {
            delete grandTotalColumn.columns;

            grandTotalColumn.show = true;
            grandTotalColumn.id = `GrandTotal`;
            grandTotalColumn.Header += `[${learner.grandtotal}]`;
            grandTotalColumn.accessor = `GrandTotal.actualscore`;

            grandTotalColumn.Cell = ({ value, row, column }) =>
              buildCell(value, row.original[column.id], column);
          }

          tableColumns.push(grandTotalColumn);
        }
      }
    });

    return { finalData, tableColumns, batchHasCC };
  };

  const handleExtension = (data) => {
    let apiurl, apidata;

    apiurl = "node/admin/duedate/extd";
    apidata = {
      // reset: false,
      // testid: data.testid,
      // libtypeid: data.libtype,
      learnerid: data.learnerid,
      // lpconfigid: data.lpconfigid, --OLD
      lpconfigid: data.lpcid,
      exdate: localStorage.getItem("extensionDate") ? localStorage.getItem("extensionDate")?.toString() : moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };

    // setIsLoaded(true);
    setLoading(true);

    axios
      .post(
        apiurl,
        JSON.stringify(apidata),
        useCommonFunctionHks.getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          // setIsLoaded(true);
          setLoading(true);
          setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.msg,
          });
          // setIsLoaded(false);
          setLoading(false);
          updateDataAfterExtDate(data);
        } else {
          setShowNotify({
            show: true,
            title: "Info",
            msg: "Something went wrong. Please, try again",
          });
        }
      })
      .catch(function (error) {
        useCommonFunctionHks.getCatchBlockDetails(error);
      })
      .finally(() => setLoading(false));
  };

  const handleExtendDate = (row) => {
    localStorage.removeItem("extensionDate");
    Alert.setExtensionDate(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));

    setShowNotify({
      show: true,
      primaryButton: "Extend",
      secondaryButton: "Cancel",
      title: "Set new Deadline",
      primaryButtonFunction: () => handleExtension(row),
      msg: <Extdialog lpid={lpId} cellobj={row} dateshow={true} />,
    });
  };

  /* OLD REPORT */
  // const buildCell = (value, row, column) => {
  //   let dueDate = moment(row?.duedate);
  //   let today = moment();
  //   let result = today.diff(dueDate, "minutes");

  //   return (
  //     <Fragment>
  //       {row?.status === constants.PROGRESS_STATUS.EVALUATED ? (
  //         <div
  //           style={{
  //             cursor: "pointer",
  //             background: handleGetCellColor(row.score_per),
  //           }}
  //           title="Evaluated"
  //           onClick={
  //             getDataFromStorage("role") === constants.Roles.hr
  //               ? ""
  //               : () => openTest(row, column.id)
  //           }
  //         >
  //           {row?.actualscore === null ? 0 : row?.actualscore}
  //         </div>
  //       ) : row?.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED ? (
  //         <div
  //           style={{ cursor: "pointer" }}
  //           title="To be evaluated"
  //           onClick={
  //             getDataFromStorage("role") === constants.Roles.hr
  //               ? ""
  //               : () => openTest(row, column.id)
  //           }
  //         >
  //           TBE
  //         </div>
  //       ) : row?.status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED ? (
  //         <div
  //           style={{ cursor: "pointer" }}
  //           title="Partially evaluated"
  //           onClick={
  //             getDataFromStorage("role") === constants.Roles.hr
  //               ? ""
  //               : () => openTest(row, column.id)
  //           }
  //         >
  //           {row?.actualscore === null ? 0 : row?.actualscore}
  //           <HourglassBottom style={{ color: "#F55533" }} />
  //         </div>
  //       ) : result > 0 &&
  //         parseInt(Alert.batchDetails.batchtype) !==
  //           constants.BATCH_TYPE.SELF ? (
  //         <div
  //           style={{ cursor: "pointer" }}
  //           title={
  //             "Post Due Date\n Duedate: " +
  //             moment(row.duedate).format("YYYY-MM-DD HH:mm:ss")
  //           }
  //           onClick={
  //             getDataFromStorage("role") === constants.Roles.hr ||
  //             getDataFromStorage("role") === constants.Roles.tutor
  //               ? ""
  //               : () => handleExtendDate(row)
  //           }
  //         >
  //           PDD
  //         </div>
  //       ) : row?.status === constants.PROGRESS_STATUS.QN_CONTINUE ? (
  //         <div
  //           style={{ cursor: "pointer" }}
  //           title={`Retake with time left\n Duedate: ${moment(
  //             row.duedate
  //           ).format("YYYY-MM-DD HH:mm:ss")}
  //           \n Timeleft : ${row.timeleft < 60 ? "0" : row.timeleft / 60} min  ${
  //             row.timeleft % 60
  //           } sec `}
  //           onClick={
  //             getDataFromStorage("role") === constants.Roles.hr
  //               ? ""
  //               : () => openTest(row, column.id)
  //           }
  //         >
  //           CON
  //         </div>
  //       ) : row?.status === constants.PROGRESS_STATUS.IN_PROGRESS ? (
  //         <div
  //           style={{ cursor: "pointer" }}
  //           title="In progress"
  //           onClick={
  //             getDataFromStorage("role") === constants.Roles.hr
  //               ? ""
  //               : () => openTest(row, column.id)
  //           }
  //         >
  //           PRO
  //         </div>
  //       ) : row?.status === constants.PROGRESS_STATUS.REATTEMPT ? (
  //         <div
  //           style={{ cursor: "pointer" }}
  //           title={`Retake\n Duedate: ${moment(row.duedate).format(
  //             "YYYY-MM-DD HH:mm:ss"
  //           )}`}
  //           onClick={
  //             getDataFromStorage("role") == constants.Roles.hr
  //               ? ""
  //               : () => openTest(row, column.id)
  //           }
  //         >
  //           RES
  //         </div>
  //       ) : row?.status === constants.PROGRESS_STATUS.LOCKED ||
  //         row?.status === constants.PROGRESS_STATUS.UNLOCKED ? (
  //         <div title="Yet to start">-</div>
  //       ) : (
  //         <div>{row?.actualscore === null ? 0 : row?.actualscore}</div>
  //       )}
  //     </Fragment>
  //   );
  // };

  const handleGetCellColor = (color, from) => {
    if (from === "pdd") {
      if (color === "bg") {
        return "#FFFBFA";
      } else {
        return "#F04438";
      }
    } else if (from === "res") {
      if (color === "bg") {
        return "#FAFAFF";
      } else {
        return "#7A5AF8";
      }
    } else if (from === "con") {
      if (color === "bg") {
        return "#FEF6FB";
      } else {
        return "#EE46BC";
      }
    } else if (from === "tbe") {
      if (color === "bg") {
        return "#FFFCF5";
      } else {
        return "#F79009";
      }
    } else if (from === "pro") {
      if (color === "bg") {
        return "#F5FAFF";
      } else {
        return "#2E90FA";
      }
    }
  };


  const buildCell = (question, studentTopicKey, topic, test, lid, name, mid) => {
    let row;
    const column = { id: test.tid }; // to match openTest(row, column.id)
    const dueDate = moment(test?.duedate);
    const today = moment();
    const result = today.diff(dueDate, "minutes");


    if (test.libtype === constants.libTypeIds.CODING_CHALLENGE) {
      row = {
        ...test,
        status: question.status,
        testConfigId: studentTopicKey,
        topicid: topic ? topic.topicid : null,
        topicname: topic ? topic.topicname : null,
        apiattributes: {
          testqnno: question.qnno,
          questionid: question.qnid,
          lpid: sessionStorage.getItem("aPathId"),
        },
      };
    } else {
      row = {
        ...question,
        apiattributes: {
          lpid: sessionStorage.getItem("aPathId"),
          questionid:question?.tooltip[0]?.libid ?? null
        },
      };
    }

    row = { ...row, learnerid: lid, lname: name, mid };

    const isHr = getDataFromStorage("role") === constants.Roles.hr;

    const handleClick = isHr ? undefined : () => {
      if (row.libtype == constants.libTypeIds.ASSIGNMENT) {
        sessionStorage.setItem("pagestate", "reportpage");
      }
      openTest({ ...row }, column.id);
    };

    // Determine display based on status
    if (row?.status === constants.PROGRESS_STATUS.EVALUATED) {
      return (
        <div
          className="score-display clickable"
          title="Evaluated"
          onClick={handleClick}
        >
          {question?.actualscore ?? 0}
        </div>
      );
    }

    if (row?.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED) {
      return (
        <div
          className="score-display clickable"
          title="To be evaluated"
          onClick={handleClick}
          style={{
            background: handleGetCellColor("bg", "tbe"),
            color: handleGetCellColor("cl", "tbe"),
            whiteSpace: 'nowrap',
          }}
        >
          {/* TBE */}
          Eval. Pending
        </div>
      );
    }

    if (row?.status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED) {
      return (
        <div
          className="score-display clickable"
          title="Partially evaluated"
          onClick={handleClick}
        >
          {question?.actualscore ?? 0} <HourglassBottom style={{ color: "#F55533" }} />
        </div>
      );
    }

    if (
      result > 0 &&
      parseInt(Alert.batchDetails.batchtype) !== constants.BATCH_TYPE.SELF
    ) {
      return (
        <div
          className="score-display clickable"
          title={`Post Due Date\nDuedate: ${moment(row.duedate).format(
            "YYYY-MM-DD HH:mm:ss"
          )}`}
          onClick={
            isHr || getDataFromStorage("role") === constants.Roles.tutor
              ? undefined
              : () => handleExtendDate(row)
          }

          style={{
            background: handleGetCellColor("bg", "pdd"),
            color: handleGetCellColor("cl", "pdd"),
            whiteSpace: 'nowrap',
          }}
        >
          Past Due
        </div>
      );
    }

    if (row?.status === constants.PROGRESS_STATUS.QN_CONTINUE) {
      return (
        <div
          className="score-display clickable"
          title={`Retake with time left\nDuedate: ${moment(row.duedate).format(
            "YYYY-MM-DD HH:mm:ss"
          )}\nTimeleft: ${row.timeleft < 60 ? "0" : Math.floor(row.timeleft / 60)
            } min ${row.timeleft % 60} sec`}
          onClick={handleClick}
          style={{
            background: handleGetCellColor("bg", "con"),
            color: handleGetCellColor("cl", "con"),
            whiteSpace: 'nowrap',
          }}
        >
          {/* CON */}
          Reopened
        </div>
      );
    }

    if (row?.status === constants.PROGRESS_STATUS.IN_PROGRESS) {
      return (
        <div
          className="score-display clickable"
          title="In progress"
          onClick={handleClick}
          style={{
            background: handleGetCellColor("bg", "pro"),
            color: handleGetCellColor("cl", "pro"),
            whiteSpace: 'nowrap',
          }}
        >
          In Progress
        </div>
      );
    }

    if (row?.status === constants.PROGRESS_STATUS.REATTEMPT || row?.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION) {
      return (
        <div
          className="score-display clickable"
          title={`Retake\nDuedate: ${moment(row.duedate).format(
            "YYYY-MM-DD HH:mm:ss"
          )}`}
          onClick={handleClick}
          style={{
            background: handleGetCellColor("bg", "res"),
            color: handleGetCellColor("cl", "res"),
            whiteSpace: 'nowrap',
          }}
        >
          {/* RES */}
          Resubmission
        </div>
      );
    }

    if (
      row?.status === constants.PROGRESS_STATUS.LOCKED ||
      row?.status === constants.PROGRESS_STATUS.UNLOCKED ||
      row?.status === null
    ) {
      return (
        result > 0 &&
          parseInt(Alert.batchDetails.batchtype) !== constants.BATCH_TYPE.SELF && row?.status !== null
          ? <div
            className="score-display clickable"
            title={`Post Due Date\nDuedate: ${moment(row.duedate).format(
              "YYYY-MM-DD HH:mm:ss"
            )}`}
            onClick={
              isHr || getDataFromStorage("role") === constants.Roles.tutor
                ? undefined
                : () => handleExtendDate(row)
            }
            style={{
              background: handleGetCellColor("bg", "pdd"),
              color: handleGetCellColor("cl", "pdd"),
              whiteSpace: 'nowrap',
            }}
          >
            Past Due
          </div>
          : <div className="score-display">-</div>);
    }

    // Default
    return (
      <div
        className="score-display clickable"
        onClick={handleClick}
      >
        {row?.actualscore ?? 0}
      </div>
    );
  };


  const openTest = (row, name) => {
    row.from = "new";
    setStatus(row.status);
    sessionStorage.setItem("lastLpid", lpId);
    ReportHks.handleOpenTestOrAssignment(row, name);
  };

  /* OLD REPORT */
  // const extractCheckedQuestions = (node,value) => {
  //   let result = [];

  //   if (node.children && node.children.length>0) {
  //     for (const child of node.children) {

  //       if (child.isQn && child.checked) {
  //         result.push(child);
  //       } else {

  //         if(child.lpcid === value){
  //           result.push(node);
  //           break;
  //         } else {
  //           result = result.concat(extractCheckedQuestions(child));
  //         }
  //       }
  //     }
  //   } else {
  //     if(node.isQn === undefined){
  //       result.push(node);
  //     }
  //   }

  //   return result;
  // };

  const extractCheckedQuestions = (node, value) => {
    let result = [];

    let count = 0;

    if (node.children && node.children.length > 0) {
      let allQuestionsChecked = true;
      let childQuestions = [];

      for (const child of node.children) {
        if (child.isQn) {
          if (child.checked) {
            childQuestions.push(child);
            count++;
          } else {
            allQuestionsChecked = false;
          }
        } else {
          const subResult = extractCheckedQuestions(child);
          if (subResult.length > 0) {
            childQuestions.push(...subResult);
          } else {
            allQuestionsChecked = false;
          }
        }
      }

      if (
        node.isModule &&
        ((allQuestionsChecked && count === node.children.length) ||
          (!allQuestionsChecked && count === 0))
      ) {
        result.push(node);
      } else {
        result.push(...childQuestions);
      }
    } else {
      if (
        node.isQn === undefined &&
        (!node.label.includes("Total") || node.label.includes("Grand Total"))
      ) {
        result.push(node);
      }
    }

    return result;
  };

  const getActualSelectedQuestions = (selectedNodes, fullTree) => {
    const selectedQns = [];

    selectedNodes.forEach((node) => {
      if (node.isQn) {
        selectedQns.push(node);
      } else {
        const matchInTree = findNodeByValue(fullTree, node.value);
        if (matchInTree) {
          const checkedQns = extractCheckedQuestions(matchInTree, node.value);
          selectedQns.push(...checkedQns);
        }
      }
    });
    return selectedQns;
  };

  const findNodeByValue = (nodes, value) => {
    for (const node of nodes) {
      if (node.value === value) {
        return node;
      }
      if (node.children) {
        const found = findNodeByValue(node.children, value);
        if (found) return found;
      }
    }
    return null;
  };

  const handleOnChange = (currentNode, selectedNodes) => {
    const actualSelectedQuestions = getActualSelectedQuestions(
      selectedNodes,
      reportTopics
    );

    let mids = "";
    let lpcids = "";
    let qns = "";
    let totalmids = "";
    let isGrandTot = false;

    actualSelectedQuestions.forEach((q) => {
      if (q.isGrandTotal) {
        isGrandTot = true;
      } else {
        if (q.isMtotal) {
          totalmids += `${q.value},`;
        } else {
          if (q.isModule && !q.isTest) {
            mids += `${q.value},`;
          } else if (q.qnno) {
            qns += `${q.value},`;
            lpcids += `${q.lpcid},`;
          } else {
            lpcids += `${q.value},`;
          }
        }
      }
    });

    if (mids.length > 0) mids = mids.slice(0, -1);
    if (lpcids.length > 0) lpcids = lpcids.slice(0, -1);
    if (qns.length > 0) qns = qns.slice(0, -1);
    if (totalmids.length > 0) totalmids = totalmids.slice(0, -1);

    setMid(mids);
    setLpcid(lpcids);
    setQns(qns);
    setTotalmids(totalmids);
    setIsGrandTotal(isGrandTot);
  };

  /* OLD REPORT */
  // const handleOnChange = (current, selected) => {
  //   let mids = "",
  //     lpcids = "",
  //     qns = "",
  //     totalmids = "",
  //     isGrandTot = false;

  //   for (let i = 0; i < selected.length; i++) {
  //     if (selected[i].isGrandTotal) isGrandTot = true;
  //     else {
  //       if (selected[i].isMtotal) {
  //         totalmids += selected[i].value + ",";
  //       } else {
  //         if (selected[i].isModule) {
  //           mids += selected[i].value + ",";
  //         } else if (selected[i].isQn) {
  //           qns += `${selected[i].value}_${selected[i].qnno},`;
  //           lpcids += selected[i].lpcid + ",";
  //         } else {
  //           lpcids += selected[i].value + ",";
  //         }
  //       }
  //     }
  //   }

  //   if (mids.length > 0) mids = mids.slice(0, -1);
  //   if (lpcids.length > 0) lpcids = lpcids.slice(0, -1);
  //   if (qns.length > 0) qns = qns.slice(0, -1);
  //   if (totalmids.length > 0) totalmids = totalmids.slice(0, -1);

  //   setTotalmids(totalmids);
  //   setMid(mids);
  //   setLpcid(lpcids);
  //   setQns(qns);
  //   setIsGrandTotal(isGrandTot);
  // };

  /* NEW ___ handleApplyFilter */

  const handleApplyFilter = (selected, { list, setList, setSelectedValue, useLabel = false }) => {
    const alreadySelected = list.find(
      (item) => item.value === selected.value && item.checked
    );

    const newList = list.map((item) => ({
      ...item,
      checked: alreadySelected ? false : selected.value === item.value,
    }));

    const current = newList.find((curr) => curr.checked);

    setList(newList);
    setSelectedValue(current?.checked ?
      (useLabel ? current?.label : current?.value) :
      null
    );
  };

  const handleRemoveFilters = (selected) => {
    const resetList = (list) => list.map(item => ({ ...item, checked: false }));

    setReportStatus(resetList(reportStatus));
    setCollegeList(resetList(collegeList));
    setBranchList(resetList(branchList));

    setSelectedStatus(null);
    setSelectedcollege(null);
    setSelectedBranch(null);
  };

  const handleApplyStatusFilters = (selected, type) => {
    if (type === "mtopic") {
      handleRemoveFilters(selected)
    } else if (type === "status") {
      handleApplyFilter(selected, {
        list: reportStatus,
        setList: setReportStatus,
        setSelectedValue: setSelectedStatus,
        useLabel: false
      });
    } else if (type === "college") {
      handleApplyFilter(selected, {
        list: collegeList,
        setList: setCollegeList,
        setSelectedValue: setSelectedcollege,
        useLabel: true
      });
      setSelectedBranch(null);
    } else if (type === "branch") {
      handleApplyFilter(selected, {
        list: branchList,
        setList: setBranchList,
        setSelectedValue: setSelectedBranch,
        useLabel: true
      });
    }
  }

  /* OLD ___ handleApplyStatusFilters  */
  // const handleApplyStatusFilters = (selected, type) => {
  //   const alreadySelected = reportStatus.find(
  //     (item) => item.value === selected.value && item.checked
  //   );

  //   const newreportStatus = reportStatus.map((item) => ({
  //     ...item,
  //     checked: alreadySelected ? false : selected.value === item.value,
  //   }));

  //   const current = newreportStatus.find((curr) => curr.checked);

  //   setReportStatus(newreportStatus);
  //   setSelectedStatus(current?.checked ? current?.value : null);
  // };

  // const handleApplyStatusFilters = (current, selected) => {
  //   setSelectedStatus(current.checked ? current.value : null);
  // };
  // const handleApplyBlockFilters = (current, selected) => {
  //   // const libtypes = _.chain(selected)
  //   //   .filter("libtype") // Select only modules
  //   //   .map("value") // Extract values
  //   //   .join(",") // Join with a comma
  //   //   .value(); // Get the final string


  //   const libtypes = selected
  //     .map((sel) => {
  //       if (sel.value === "assignment") return constants.libTypeIds.ASSIGNMENT;
  //       if (sel.value === "ccq") return constants.libTypeIds.CODING_CHALLENGE;
  //       if (sel.value === "descriptive")
  //         return constants.libTypeIds.DESCRIPTIVE;
  //       if (sel.value === "mcq") return constants.libTypeIds.MCQ;
  //       return null; // Return null instead of empty string
  //     })
  //     .filter(Boolean) // Remove null values
  //     .join(",");
  //   setLibtype(libtypes);

  //   // const lstatus = _.chain(selected)
  //   //   .filter("lstatus")
  //   //   .map("value")
  //   //   .join(",")
  //   //   .value();
  //   // setLStatus(lstatus);

  //   if (!selected.length) setLStatus("");
  //   setTesMode(constants.MODE.TEST_MODE);

  //   // const newTypesAndModules = JSON.parse(JSON.stringify(typesAndModules));
  //   // selected.forEach((sel) => {
  //   //   newTypesAndModules.forEach((item) => {
  //   //     item.checked = item.value === sel.value;

  //   //     if(sel.value === "active") setLStatus(true);
  //   //     if(sel.value === "inactive") setLStatus(false);
  //   //   });
  //   // });

  //   // Update the `checked` state correctly for multiple selections
  //   const newTypesAndModules = typesAndModules.map((item) => ({
  //     ...item,
  //     checked: selected.some((sel) => sel.value === item.value), // Check if selected
  //   }));

  //   selected.forEach((sel) => {
  //     if (sel.value === "active") setLStatus(true);
  //     if (sel.value === "inactive") setLStatus(false);
  //     if (sel.value === "practice") setTesMode(constants.MODE.PRACTICE_MODE);
  //   });

  //   setTypesAndModules(newTypesAndModules);
  // };

  const handleApplyBlockFilters = (selected) => {
    const selectedArr = Array.isArray(selected) ? selected : [selected];

    const alreadySelected = typesAndModules.find(
      (item) => item.value === selected.value && item.checked
    );

    let libtypes = null;

    if (!alreadySelected) {
      libtypes = selectedArr
        .map((sel) => {
          if (sel.value === "assignment") return constants.libTypeIds.ASSIGNMENT;
          if (sel.value === "ccq") return constants.libTypeIds.CODING_CHALLENGE;
          if (sel.value === "descriptive") return constants.libTypeIds.DESCRIPTIVE;
          if (sel.value === "codingsnippet") return constants.libTypeIds.CODING_SNIPPET;
          if (sel.value === "mcq") return constants.libTypeIds.MCQ;
          if (sel.value === "sql") return constants.libTypeIds.SQL;
          return null; // Return null instead of empty string
        })
        .filter(Boolean) // Remove null values
        .join(",");
    }

    setLibtype(libtypes || null);

    setLStatus(true);
    if (!selectedArr.length) setLStatus("");
    setTesMode(constants.MODE.TEST_MODE);

    // Update the `checked` state correctly for multiple selections
    const newTypesAndModules = typesAndModules.map((item) => ({
      ...item,
      checked: alreadySelected
        ? false
        : selectedArr.some((sel) => sel.value === item.value), // Check if selected
    }));

    selectedArr.forEach((sel) => {
      if (sel.value === "active") setLStatus(true);
      if (sel.value === "inactive") alreadySelected ? setLStatus(true) : setLStatus(false);
      if (sel.value === "practice") alreadySelected ? setTesMode(constants.MODE.TEST_MODE) : setTesMode(constants.MODE.PRACTICE_MODE);
    });

    setTypesAndModules(newTypesAndModules);
  };

  const getLeavesForspan = (column, span) => {
    if (column.hasOwnProperty("columns")) {
      for (var i = 0; i < column.columns.length; i++) {
        span = getLeavesForspan(column.columns[i], span);
      }
      return span;
    }
    span++;
    return span;
  };

  const getCellValue = (row) => {
    let dueDate = moment(row?.duedate);
    let today = moment();
    let result = today.diff(dueDate, "minutes");
    let value =
      row?.status === constants.PROGRESS_STATUS.EVALUATED
        ? row?.actualscore === null
          ? 0
          : row?.actualscore
        : row?.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED
          ? "TBE"
          : row?.status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED
            ? row?.actualscore === null
              ? 0
              : row?.actualscore
            : result > 0 && parseInt(Alert.batchDetails.batchtype) !== constants.BATCH_TYPE.SELF
              ? "PDD"
              : row?.status === constants.PROGRESS_STATUS.QN_CONTINUE
                ? "CON"
                : row?.status === constants.PROGRESS_STATUS.IN_PROGRESS
                  ? "PRO"
                  : row?.status === constants.PROGRESS_STATUS.REATTEMPT || row?.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION
                    ? "RES"
                    : row?.status === constants.PROGRESS_STATUS.LOCKED ||
                      row?.status === constants.PROGRESS_STATUS.UNLOCKED
                      ? "-"
                      : row?.actualscore === null
                        ? 0
                        : row?.actualscore;
    return value;
  };

  const getExcel = async (event) => {
    event.preventDefault();
    const config = {
      filename: "Report",
      sheet: {
        data: [],
      },
    };
    let results = await handleGetReport(
      lpid,
      studentPage,
      testPage,
      debouncedSearchValue,
      mid,
      lpcid,
      libtype,
      lStatus,
      qns,
      selectedStatus,
      totalmids,
      isGrandTotal,
      true,
      tesMode,
      selectedcollege,
      selectedBranch
    );
    var columns = [{ width: 0 }];

    const dataSet = config.sheet.data;

    // review with one level nested config
    // HEADERS

    if (results.data.finalData?.length > 0) {
      headerGroups.forEach((headerGroup, groupind) => {
        const headerRow = [];

        if (headerGroup.headers) {
          headerGroup.headers
            // .filter(
            //   (column) =>
            //     column.accessor !== "email" &&
            //     column.accessor !== "branch" &&
            //     column.accessor !== "college"
            // ) // Remove unwanted columns
            .forEach((column, ind) => {
              let calvalue;

              if (column.hasOwnProperty("columns")) {
                if (
                  column.accessor === undefined &&
                  (typeof column["Header"] == "function" ||
                    typeof column["Header"] == "object")
                )
                  calvalue = "";
                else calvalue = column.Header;
              } else {
                calvalue = column.Header;
              }

              if (column.hasOwnProperty("columns")) {
                var colspan = getLeavesForspan(column, 0);
                headerRow.push({
                  value: calvalue,
                  width: 30,
                  wrap: true,
                  align: "center",
                  fontWeight: "bold",
                  borderStyle: "dotted",
                  backgroundColor: "#F2F4F7",
                  span: getLeavesForspan(column, 0),
                });
                for (var t = 1; t < colspan; t++) {
                  headerRow.push({
                    span: 1,
                    value: "",
                    width: 30,
                    wrap: true,
                    align: "center",
                    fontWeight: "bold",
                    borderStyle: "dotted",
                    backgroundColor: "#F2F4F7",
                  });
                }
              } else {
                if (typeof column["Header"] == "string") {
                  headerRow.push({
                    span: 1,
                    width: 30,
                    wrap: true,
                    align: "center",
                    fontWeight: "bold",
                    value: column.Header,
                    borderStyle: "dotted",
                    backgroundColor: "#F2F4F7",
                  });
                } else if (typeof column["accessor"] == "string") {
                  headerRow.push({
                    span: 1,
                    width: 30,
                    wrap: true,
                    align: "center",
                    fontWeight: "bold",
                    value: column.Header,
                    borderStyle: "dotted",
                    backgroundColor: "#F2F4F7",
                  });
                } else if (
                  typeof column["Header"] == "object" &&
                  typeof column["accessor"] == "function"
                ) {
                  headerRow.push({
                    span: 1,
                    width: 30,
                    wrap: true,
                    align: "center",
                    fontWeight: "bold",
                    borderStyle: "dotted",
                    backgroundColor: "#F2F4F7",
                    value: column.Header.props.children,
                  });
                } else {
                  headerRow.push({
                    span: 1,
                    value: "",
                    width: 30,
                    wrap: true,
                    align: "center",
                    fontWeight: "bold",
                    borderStyle: "dotted",
                    backgroundColor: "#F2F4F7",
                  });
                }
              }

              if (
                ind > 0 &&
                !column.hasOwnProperty("columns") &&
                groupind === headerGroups.length - 1
              ) {
                let callength = calvalue.length + 6;

                columns.push({ width: callength });
              }
            });
        }
        if (groupind === 0) {
          // Add actual headers
          headerRow.splice(
            1,
            0,
            {
              span: 1,
              width: 30,
              wrap: true,
              align: "center",
              fontWeight: "bold",
              value: "Email",
              borderStyle: "dotted",
              backgroundColor: "#F2F4F7",
            },
            {
              span: 1,
              width: 30,
              wrap: true,
              align: "center",
              fontWeight: "bold",
              value: "College",
              borderStyle: "dotted",
              backgroundColor: "#F2F4F7",
            },
            {
              span: 1,
              width: 30,
              wrap: true,
              align: "center",
              fontWeight: "bold",
              value: "Branch",
              borderStyle: "dotted",
              backgroundColor: "#F2F4F7",
            }
          );
        } else {
          // Add EMPTY cells for alignment in 2nd and 3rd row
          headerRow.splice(
            1,
            0,
            {
              span: 1,
              value: "",
              width: 30,
              wrap: true,
              align: "center",
              fontWeight: "bold",
              borderStyle: "dotted",
              backgroundColor: "#F2F4F7",
            },
            {
              span: 1,
              value: "",
              width: 30,
              wrap: true,
              align: "center",
              fontWeight: "bold",
              borderStyle: "dotted",
              backgroundColor: "#F2F4F7",
            },
            {
              span: 1,
              value: "",
              width: 30,
              wrap: true,
              align: "center",
              fontWeight: "bold",
              borderStyle: "dotted",
              backgroundColor: "#F2F4F7",
            }
          );
        }

        dataSet.push(headerRow);
      });

      // FILTERED ROWS

      if (results.data.finalData.length > 0) {
        let callength = 0;

        results.data.finalData.forEach((row) => {
          const dataRow = [];

          let viewColumns = [];

          Object.keys(row).forEach((key) => {
            if (
              typeof row[key] === "object" &&
              row[key] !== null &&
              key !== "name" &&
              key !== "testdata" &&
              key !== "lname" &&
              key !== "lid"
            ) {
              let value = getCellValue(row[key]);
              dataRow.push({
                value: value,
                align: "center",
              });
            }
          });
          dataRow.unshift({
            value: row.branch,
            align: "center",
          });
          dataRow.unshift({
            value: row.college,
            align: "center",
          });
          dataRow.unshift({
            value: row.email,
            align: "center",
          });
          dataRow.unshift({
            value: row.lname,
            align: "center",
          });
          dataSet.push(dataRow);
        });
        columns[0] = { width: callength };
        columns[columns.length - 1] = { width: 25 };
      } else {
        dataSet.push([
          {
            value: "No data",
          },
        ]);
      }

      return await writeXlsxFile(dataSet, {
        columns,
        fileName: "report.xlsx",
      });
    } else {
      setShowNotify({
        show: true,
        title: "Info",
        msg: "No data available for download.",
      });
    }
  };

  const updateDataAfterExtDate = (data) => {
    let keysToAvoid = ["name", "testdata", "GrandTotal", "total", "GrandTotal", "branch", "email", "lid", "lname"];

    const learnersData = JSON.parse(JSON.stringify(viewLearnerData.current));
    const updatedLData = { ...resLData };

    Object.entries(updatedLData).forEach(([key, student]) => {
      if (data.learnerid === student.id) {
        student.modules[data.mid].tests[data.tid].duedate = localStorage.getItem('extensionDate');
      }
    });
    setResLData(updatedLData ?? {});

    let updatedData = _.map(learnersData, (learner) => {
      if (learner.lid == data.learnerid) {
        if (data.libtype === constants.libTypeIds.CODING_CHALLENGE) {
          let keys = Object.keys(learner).filter(
            (key) => !key.includes("total") && !keysToAvoid.includes(key)
          );

          for (let key = 0; key < keys.length; key++) {
            // if (learner[keys[key]]?.testid === data.testid) --OLD
            if (learner[keys[key]]?.testid === data.tid)
              learner[keys[key]].duedate =
                localStorage.getItem("extensionDate");
          }
        } else {
          // learner[data.accessor].duedate = localStorage.getItem("extensionDate"); --OLD

          let keys = Object.keys(learner).filter(
            (key) => !key.includes("total") && !keysToAvoid.includes(key)
          );
          for (let key = 0; key < keys.length; key++) {
            if (learner[keys[key]]?.testid === data.tid)
              learner[keys[key]].duedate = localStorage.getItem("extensionDate");
          }
        }
      }

      localStorage.removeItem("extensionDate");

      return learner;
    });

    viewLearnerData.current = updatedData;
    setData(updatedData);
  };

  const onScroll = () => {
    // const { scrollTop, scrollHeight, clientHeight } = reportTableRef.current;

    // if (isLoaded || !hasMore) return;

    // if (scrollTop + clientHeight >= scrollHeight - 10) {
    //   setStudentPage((prev) => prev + 1);
    // }
    const div = reportTableRef.current;
    if (!div || isLoaded || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = div;

    sessionStorage.setItem("admin-reports-table-div", JSON.stringify(scrollTop));

    if (scrollTop + clientHeight >= scrollHeight - 100) { // give 100px leeway
      setStudentPage(prev => prev + 1);
    }
  };

  useEffect(() => {
    const hasChecked = typesAndModules.some((item) => item.checked);

    if (hasChecked) {
      const newTypesAndModules = typesAndModules.map((item) => ({
        ...item,
        checked: false,
      }));

      setTypesAndModules(newTypesAndModules);
    }
  }, []);

  const toggleTest = (moduleId, testId) => {
    const key = `${moduleId}-${testId}`;
    if (expandMid.current === null || expandMid.current !== moduleId) {
      expandMid.current = moduleId;
    } else {
      expandMid.current = null;
    }
    setExpandedTests(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const isExpandedColumn = (moduleId, testId) => {
    return expandedTests[`${moduleId}-${testId}`] === true;
  };

  useEffect(() => {
    return () => {
      // This runs when you navigate away from Report page      
      setSearchText("");
    };
  }, []);

  return (
    <div id="report-main" className="report-main">
      {loading && <Loading overlay/>}
      <div class="new_reportLpName">{sessionStorage.getItem("aPathName")}</div>
      <ReportFilterAndSearch
        columns={columns}
        getExcel={getExcel}
        status={reportStatus}
        setColumns={setColumns}
        // globalFilter={searchText}
        topicFilData={reportTopics}
        // setSearchText={setSearchText}
        handleOnChange={handleOnChange}
        // setGlobalFilter={setSearchText}
        typesAndModules={typesAndModules}
        setHiddenColumns={setHiddenColumns}
        handleGetReport={() => setRefreshPage(true)}
        handleApplyBlockFilters={handleApplyBlockFilters}
        setHiddenColumnsInTable={setHiddenColumnsInTable}
        handleApplyStatusFilters={handleApplyStatusFilters}
        refreshPage={refreshPage}
      />
      {/* <div
        ref={reportTableRef}
        className="scrollable-body"
        id="admin-reports-table-div"
        onScroll={(event) => {
          sessionStorage.setItem(
            "admin-reports-table-div",
            JSON.stringify(event.target.scrollTop)
          );
          onScroll();
        }}
      >
        <table {...getTableProps()}>
          <thead id="admin-reports-table-head-div">
            {headerGroups?.map((headerGroup, hgindex) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers?.map((column, index) => {
                  const { key } = column.getHeaderProps();
                  return (
                    <th
                      key={key}
                      className="report-thead-th"
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <span className="report-thead-th-div-span">
                        <AutoTextSize
                          mode="multiline"
                          minFontSizePx="6"
                          maxFontSizePx="16"
                        >
                          {column.render("Header")}
                        </AutoTextSize>
                      </span>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr key={row.id} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td
                        className="report-table-data-cell"
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div> */}



      <div className="hierarchy-table-container">
        {studentsArray.length > 0 ? (
          <div className="table-wrapper">
            <div
              ref={reportTableRef}
              className="scrollable-body"
              id="admin-reports-table-div"
              onScroll={(event) => {
                sessionStorage.setItem(
                  "admin-reports-table-div",
                  JSON.stringify(event.target.scrollTop)
                );
                onScroll();
              }}
            >
              <table className="hierarchy-table">
                <thead>
                  {/* Module Header Row */}
                  <tr className="module-headers">
                    <th className="student-header" rowSpan="3">Name</th>
                    {selectedDropdown?.college?.label === "All" && <th className="test-header" rowSpan="3">College</th>}
                    {selectedDropdown?.branch?.label === "All" && <th className="test-header" rowSpan="3">Branch</th>}
                    {Object.values(headerStructure).map(module => (
                      <th
                        key={module.mid}
                        className="module-header"
                        colSpan={Object.values(module.tests).reduce((moduleTotal, test) => {
                          if (test.libtype === 5 && expandedTests[`${module.mid}-${test.tid}`]) {
                            // Sum up the number of questions in all topics for this test
                            const totalQuestions = Object.values(test.topics).reduce((testTotal, topic) => {
                              const questionCount = topic.questions ? Object.keys(topic.questions).length : 1;
                              return testTotal + questionCount;
                            }, 0);
                            return moduleTotal + totalQuestions + 1;
                          }
                          // collapsed or non-libtype-5 tests count as 1 column
                          return moduleTotal + 1;
                        }, 0)}
                      >
                        <div className="module-title">
                          {`${module.mname} (${module.mtotal})`}
                          {/* <span className="module-score">[{module.mtotal}]</span> */}
                        </div>
                      </th>
                    ))}
                  </tr>

                  {/* Test Header Row */}
                  <tr className="test-headers">
                    {Object.values(headerStructure).map(module =>
                      Object.values(module.tests).map(test => {
                        let totalQuestions = 0;

                        if (test.libtype === 5 && expandedTests[`${module.mid}-${test.tid}`]) {
                          totalQuestions = Object.values(test.topics).reduce((acc, topic) => {
                            const questionCount = topic.questions ? Object.keys(topic.questions).length : 1;
                            return acc + questionCount;
                          }, 0);
                        }

                        return (
                          <th
                            key={test.tid}
                            className={`test-header ${test.libtype === 5 ? 'collapsible' : ''}`}
                            colSpan={
                              test.libtype === 5 && expandedTests[`${module.mid}-${test.tid}`]
                                ? totalQuestions + 1
                                : 1
                            }
                          >
                            <div className="test-header-content">
                              {test.libtype === 5 ? (
                                <div className="header-content-div">
                                  <div className="header_toggle_test" onClick={() => toggleTest(module.mid, test.tid)}>{expandedTests[`${module.mid}-${test.tid}`] ? <div className="chevron_expand"><Chevrons_right /></div> : <div className="chevron_not_expand"><Chevrons_right /></div>}</div>
                                  <div className="header_testname"><Tooltip placement="top" title={test.tname} maxChars={21} className="testname"><span className="testname">{test.tname}</span></Tooltip><span className="test_score">{`(${test.targetscore})`}</span></div>
                                </div>
                              ) : (
                                <div className="header-content-test-div">
                                  <div className="header_testname"><Tooltip placement="top" title={test.tname} maxChars={21} className="testname"><span className="testname">{test.tname}</span></Tooltip><span className="test_score">{`(${test.targetscore})`}</span>
                                    <span>
                                      <Tooltip
                                        theme={"light"}
                                        title={
                                          <div className="report_tt_div">
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">Graded : </span><span className="report_tt_status_count">{test.tooltip[0].graded_count}</span></div>
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">Submitted : </span><span className="report_tt_status_count">{test.tooltip[0].submitted_count}</span></div>
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">In Progress : </span><span className="report_tt_status_count">{test.tooltip[0].yet_to_submit_count}</span></div>
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">Resubmission : </span><span className="report_tt_status_count">{test.tooltip[0].resubmission_count}</span></div>
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">Yet To Start : </span><span className="report_tt_status_count">{test.tooltip[0].not_yet_started_count}</span></div>
                                          </div>
                                        }
                                        placement="top"
                                      >
                                        <div>
                                          <InfoSvg rheader={true} />
                                        </div>
                                      </Tooltip>
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </th>
                        );
                      })
                    )}
                  </tr>

                  {/* Topic Header Row */}
                  <tr className="topic-headers">
                    {Object.values(headerStructure).map(module =>
                      Object.values(module.tests).map(test => {
                        const key = `${module.mid}-${test.tid}`;
                        const isExpanded = expandedTests[key];
                        const anyExpanded = Object.values(expandedTests).includes(true);

                        if (test.libtype === 5 && isExpanded) {
                          const totalTopicScore = test.targetscore;
                          return (
                            <React.Fragment key={`${module.mid}-${test.tid}`}>
                              {/* Render all topics & questions */}
                              {Object.entries(test.topics).map(([key, topic]) => {
                                const questionCount = Object.keys(topic.questions).length;
                                const totalTopicScore = Object.keys(topic.questions).length * topic.topicscore;
                                let tooltipData = test.tooltip.find(ttp => ttp.testconfigid == key);

                                return (
                                  <th
                                    key={`${module.mid}-${test.tid}-${topic.topicid}`}
                                    // className="topic-header"
                                    className={`topic-header ${isExpandedColumn(module.mid, test.tid) ? "t-expanded-highlight" : ""
                                      }`}
                                    colSpan={questionCount}
                                  >
                                    <div className="topic-title">
                                      <Tooltip placement="top" title={topic.topicname} maxChars={17} className="topic-title">
                                        {`${topic.topicname} (${totalTopicScore})`}
                                      </Tooltip>
                                      <Tooltip
                                        theme={"light"}
                                        title={
                                          <div className="report_tt_div">
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">Graded : </span><span className="report_tt_status_count">{tooltipData.graded_count}</span></div>
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">Submitted : </span><span className="report_tt_status_count">{tooltipData.submitted_count}</span></div>
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">In Progress : </span><span className="report_tt_status_count">{tooltipData.yet_to_submit_count}</span></div>
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">Resubmission : </span><span className="report_tt_status_count">{tooltipData.resubmission_count}</span></div>
                                            <div className="report_tt_status_div"><span className="report_tt_status_name">Yet To Start : </span><span className="report_tt_status_count">{tooltipData.not_yet_started_count}</span></div>
                                          </div>
                                        }
                                        placement="top"
                                      >
                                        <div>
                                          <InfoSvg rheader={true} />
                                        </div>
                                      </Tooltip>
                                    </div>
                                  </th>
                                );
                              })}

                              {/* ✅ Add one Total column after all topics */}
                              <th
                                key={`total-${module.mid}-${test.tid}`}
                                // className="topic-header total-header"
                                className={`topic-header total-header ${isExpandedColumn(module.mid, test.tid) ? "t-expanded-highlight" : ""
                                  }`}
                              >
                                <div className="topic-title">{`Total (${totalTopicScore})`}</div>
                              </th>
                            </React.Fragment>
                          );
                        }
                        else {
                          return anyExpanded ? <th key={test.tid} className="topic-header"></th> : null;
                        }
                      })
                    )}
                  </tr>
                </thead>

                <tbody>
                  {filteredStudents.map(student => (
                    <tr key={student.id} className="student-row">
                      <td className="student-name-cell">
                        <div className="student-info">
                          <div className="student-name"><Tooltip placement="top" title={student.name} maxChars={17} className="student-name">{student?.name ? student.name?.trim() : "-"}</Tooltip></div>
                        </div>
                      </td>
                      {selectedDropdown?.college?.label === "All" && <td className="score-cell">
                        <div className="student-info">
                          <div className="student-name"><Tooltip placement="top" title={student.college} maxChars={17} className="student-name">{student?.college ? student.college?.trim() : "-"}</Tooltip></div>
                        </div>
                      </td>}
                      {selectedDropdown?.branch?.label === "All" && <td className="score-cell test-score">
                        <div className="student-info">
                          <div className="student-name"><Tooltip placement="top" title={student.branch} maxChars={17} className="student-name">{student?.branch ? student.branch?.trim() : "-"}</Tooltip></div>
                        </div>
                      </td>}

                      {Object.values(headerStructure).map(module =>
                        Object.values(module.tests).map(test => {
                          const studentTest = student.modules[module.mid]?.tests[test.tid];

                          // No test data
                          if (!studentTest) {
                            if (test.libtype === 5 && expandedTests[`${module.mid}-${test.tid}`]) {
                              const topicTds = Object.values(test.topics).flatMap(topic =>
                                Object.values(topic.questions).map((_, idx) => (
                                  <td
                                    key={`${student.id}-${test.tid}-${topic.topicname}-${idx}`}
                                    className="score-cell empty"
                                  >
                                    <div className="score-display">-</div>
                                  </td>
                                ))
                              );

                              return (
                                <React.Fragment key={`${student.id}-${test.tid}-empty`}>
                                  {topicTds}
                                  <td className="score-cell total-score">
                                    <div className="score-display">-</div>
                                  </td>
                                </React.Fragment>
                              );
                            }

                            return (
                              <td key={`${student.id}-${test.tid}`}
                                // className="score-cell test-score"
                                className={`score-cell test-score ${isExpandedColumn(module.mid, test.tid) ? "expanded-highlight" : ""
                                  }`}
                              >
                                <div className="score-display clickable">-</div>
                              </td>
                            );
                          }

                          // Expanded libtype=5 test (topic-based)
                          if (test.libtype === 5 && expandedTests[`${module.mid}-${test.tid}`]) {
                            let totalActualScore = 0;

                            const topicTds = Object.values(test.topics).flatMap(topic => {
                              const studentTopic = Object.values(studentTest.topics).find(
                                item => item.topicname === topic.topicname && item.complexityid === topic.complexityid
                              );
                              const studentTopicEntry = Object.entries(studentTest.topics || {}).find(
                                ([key, value]) => value.topicname === topic.topicname && value.complexityid === topic.complexityid
                              )
                              const studentTopicKey = studentTopicEntry ? studentTopicEntry[0] : null;

                              const questions = studentTopic
                                ? Object.values(studentTopic.questions)
                                : [];

                              if (questions.length === 0) {
                                return (
                                  <td
                                    key={`${student.id}-${test.tid}-${topic.topicname}-empty`}
                                    // className="score-cell topic-score"
                                    className={`score-cell topic-score ${isExpandedColumn(module.mid, test.tid) ? "expanded-highlight" : ""
                                      }`}
                                  >
                                    <div className="score-display">-</div>
                                  </td>
                                );
                              }

                              return questions.map((q, idx) => {
                                totalActualScore += Number(q.actualscore) || 0;
                                return (
                                  <td
                                    key={`${student.id}-${test.tid}-${topic.topicname}-q${idx}`}
                                    // className="score-cell topic-score"
                                    className={`score-cell topic-score ${isExpandedColumn(module.mid, test.tid) ? "expanded-highlight" : ""
                                      }`}
                                  >
                                    {buildCell(q, studentTopicKey, topic, studentTest, student.id, student.name, module.mid)}
                                  </td>
                                );
                              });
                            });

                            return (
                              <React.Fragment key={`${student.id}-${test.tid}-total`}>
                                {topicTds}
                                <td
                                  // className="score-cell total-score"
                                  className={`score-cell total-score ${isExpandedColumn(module.mid, test.tid) ? "expanded-highlight" : ""
                                    }`}
                                >
                                  <div className="score-display total">{totalActualScore}</div>
                                </td>
                              </React.Fragment>
                            );
                          }

                          // ✅ Normal test
                          if (test.libtype === 5) {
                            return (
                              <td
                                // className="score-cell total-score"
                                className={`score-cell total-score ${isExpandedColumn(module.mid, test.tid) ? "expanded-highlight" : ""
                                  }`}
                              >
                                <div className="score-display total">{studentTest.actualscore}</div>
                              </td>
                            );
                          } else {
                            return (
                              <td
                                key={`${student.id}-${test.tid}`}
                                // className="score-cell test-score"
                                className={`score-cell test-score ${isExpandedColumn(module.mid, test.tid) ? "expanded-highlight" : ""
                                  }`}
                              >
                                {buildCell(studentTest, null, null, studentTest, student.id, student.name, module.mid)}
                              </td>
                            );
                          }
                        })
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>) : (
          <div className="rpt_nodata_msg_div">
            <div className="rpt_nodata_msg">
              {selectedStatus ? "There is no data available to display for this selection." : "No assignments available yet. Add assignments to generate reports."}
            </div>
            <div className="rpt_nodata_img">
              <Report_nodata />
            </div>
          </div>
        )}
      </div>


      {isCommonPopup && (
        <div className="popup-overlay">
          <Popup />
        </div>
      )}
      {/* {isLoaded && <Loading overlay/>} */}
    </div>
  );
};

export default Report;
